import { Col, Row } from 'react-bootstrap';

import CmsImage from '~/components/cms/CmsImage';
import { CmsImageCollectionProps } from '~/types/Cms';

const CmsImageCollection = ({ data }: CmsImageCollectionProps) => {
  const images = data?.images || [];
  const imagesLength = images.length;
  let columnSize = 12;

  if (imagesLength >= 4) {
    columnSize = 3;
  } else if (imagesLength === 3) {
    columnSize = 4;
  } else if (imagesLength === 2) {
    columnSize = 6;
  } else {
    columnSize = 12;
  }

  return (
    <Row className="row-gap-3">
      {images.map((image, index) => (
        <Col key={index} xs={12} lg={columnSize}>
          <CmsImage data={image} />
        </Col>
      ))}
    </Row>
  );
};

export default CmsImageCollection;
